import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";

@Injectable()
export class AccommodationService {
  constructor(private http: HttpClient) {}

  getAccommodation() {
    return this.http.get(`/api/internalaccommodation/getAccommodation`, {
      responseType: "json",
      observe: "response"
    });
  }

  getAllAccommodation() {
    return this.http.get(`/api/internalaccommodation/getAllAccommodation`);
  }

  getAccommodationCategory() {
    return this.http.get(
      `/api/internalaccommodation/getAccommodationCategory`,
      {
        responseType: "json",
        observe: "response"
      }
    );
  }

  getExistingAccomms(requestId: string) {
    return this.http.get(`/api/internalaccommodation/getExistingAccomms`, {
      params: { requestId: requestId },
      responseType: "json"
    });
  }

  saveAccommodations(request: any): Observable<Object> {
    return this.http.post(`/api/internalaccommodation/save`, request);
  }

  /**
   * @description Gets details for a given accommodation_nm.
   * @requires ACCOMMODATION_NM
   * @return Single Accommodation object from database.
   */
  getAccommodationByNm(accommodationNm: string) {
    return this.http.get(`/api/internalaccommodation/getAccommodationByNm`, {
      params: { type: accommodationNm },
      responseType: "json"
    });
  }

  addAccommodation(data: any): Observable<Object> {
    return this.http.post(`/api/internalaccommodation/addAccomodation`, data);
  }

  editAccommodation(data: any): Observable<Object> {
    return this.http.put(
      `/api/internalaccommodation/editAccomodation`,
      data,
      {}
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/services/accommodation.service.ts